import * as actionTypes from './actionTypes';
import * as actions from './index';
import * as Metadata from 'Flow2/containers/Masterdata/Masterdata';

export const getNewsroomTree = (type = 'default', id = 0) => {
    return dispatch => {
		dispatch({ type: actionTypes.GET_NEWSROOM_TREE_START });
        try {
			window.flow.newsroomprojectGetFullTree(type, id).then(res => {
				console.log(res);
				dispatch({ type: actionTypes.GET_NEWSROOM_TREE_SUCCESS, children: res.children });
			}).catch(res => {
				dispatch({ type: actionTypes.GET_NEWSROOM_TREE_FAIL });
				dispatch(actions.applicationError(res.message));
			});			
		} catch(err) {
			console.log("newsroom does not exist!");
		}
    };
};

export const getNewsroomByNewsroom = (type = 'default', id = 0) => {
    return dispatch => {
		dispatch({ type: actionTypes.GET_NEWSROOM_BY_NEWSROOM_START });
        window.flow.getNewsroomprojectsForNewsroom('test',0).then(res => {
			dispatch({ type: actionTypes.GET_NEWSROOM_BY_NEWSROOM_SUCCESS, newsrooms: res.objects.elements });
        }).catch(res => {
            dispatch({ type: actionTypes.GET_NEWSROOM_BY_NEWSROOM_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const newNewsroom = (title, type = 'default', id = 0) => {
    return dispatch => {
		dispatch({ type: actionTypes.NEW_NEWSROOM_START });
        window.flow.newNewsroomproject(type, id, { title: title }).then(res => {
			dispatch({ type: actionTypes.NEW_NEWSROOM_SUCCESS });
			dispatch(actions.getNewsroomTree());
        }).catch(res => {
            dispatch({ type: actionTypes.NEW_NEWSROOM_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const deleteNewsroom = (id) => {
    return dispatch => {
		dispatch({ type: actionTypes.DELETE_NEWSROOM_START });
        window.flow.delNewsroomproject(id).then(res => {
			dispatch({ type: actionTypes.DELETE_NEWSROOM_SUCCESS });
			dispatch(actions.getNewsroomTree());
        }).catch(res => {
            dispatch({ type: actionTypes.DELETE_NEWSROOM_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const addNewsroomChild = (newsroomId, childId) => {
    return (dispatch => {
        dispatch({ type: actionTypes.NEWSROOM_CHILD_ADD_START });
        window.flow.newsroomprojectAddChild(newsroomId, childId).then(res => {
            // child added
            dispatch({ type: actionTypes.NEWSROOM_CHILD_ADD_SUCCESS });
            dispatch(actions.getNewsroomTree());
        }).catch(res => {
            dispatch({ type: actionTypes.NEWSROOM_CHILD_ADD_FAIL });
        });
    });
}

export const addNewNewsroomChild = (newsroomId, title, type = 'default', id = 0) => {
    return (dispatch => {
        dispatch({ type: actionTypes.NEWSROOM_CHILD_ADD_START });
        window.flow.newsroomprojectAddNewChild(newsroomId, type, id, {'title':title}).then(res => {
            // child added
            dispatch({ type: actionTypes.NEWSROOM_CHILD_ADD_SUCCESS });
            dispatch(actions.getNewsroomTree());
        }).catch(res => {
            dispatch({ type: actionTypes.NEWSROOM_CHILD_ADD_FAIL });
        });
    });
}

// clipIds: string of ids seperated by ','
export const removeClipsFromNewsroom = (newsroomId, clipIds) => {
    return ((dispatch) => {
        dispatch({ type: actionTypes.NEWSROOM_REMOVE_CLIPS_START });
        window.flow.newsroomprojectRemoveClipById(newsroomId, clipIds).then(res => {
            dispatch({ type: actionTypes.NEWSROOM_REMOVE_CLIPS_SUCCESS });
            // reload cliplist
            dispatch(actions.getClipsForClipList(Metadata.OBJECT_TYPE_DISTRIBUTION, newsroomId));
        }).catch(res => {
            dispatch({ type: actionTypes.NEWSROOM_REMOVE_CLIPS_FAIL });
        }); 
    });
}

export const setActiveNewsroom = (id = null) => {
    return ((dispatch) => {
        dispatch({ type: actionTypes.NEWSROOM_SET_ACTIVE, id: id });
    });
}
